import { getRoutes } from './routes';
import { default as state } from './state';
import { default as locales } from './locales';

export const config = function(store) {
    return {routes: getRoutes(store), state, locales};
};